import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgWizardService } from 'ng-wizard';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-create-carton',
  templateUrl: './create-carton.component.html',
  styleUrls: ['./create-carton.component.scss']
})
export class CreateCartonComponent implements OnInit {
  @Output() createCartonData: EventEmitter<boolean> = new EventEmitter;
  @Output() campaignID: EventEmitter<number> = new EventEmitter;
  @Output() caplimit: EventEmitter<number> = new EventEmitter;
  @Output() cartonType: EventEmitter<number> = new EventEmitter;


  @Input() id = "";
  @Input() cartonid = "";
  formGroup;
  presentDate:any ;
  cartoontype1:boolean;
  editCarton = {
    caront_type: 1,
    carton_campaign_title: "",
    created_date: "",
    end_date: "",
    id: "",
    is_caplimit_overall: 0,
    module_enable_notification: "",
    module_expiry_notification: "",
    no_of_days: "",
    scan_limit: "",
    start_date: "",
    status: "",
    total_whitelist_users: "",
    updated_date: "",
  }

  constructor(
    private ngWizardService: NgWizardService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toast: ToastClientService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
  ) {
  }

  ngOnInit() {
    this.presentDate = new Date().toISOString().slice(0, 10);


    this.cartonType.emit(this.editCarton.caront_type)
    this.formGroup = this.fb.group({
      carton_type:new FormControl("",Validators.required),
      carton_campaign_title: new FormControl("", [Validators.required, Validators.pattern("[a-zA-Z0-9 ]*")]),
      caront_type: new FormControl("", [Validators.required]),
      start_date: new FormControl("", [Validators.required]),
      end_date: new FormControl("", [Validators.required]),
      // module_enable_notification: new FormControl("", [Validators.required,Validators.pattern("[a-zA-Z ]*")]),
      // module_expiry_notification: new FormControl("", [Validators.required,Validators.pattern("[a-zA-Z ]*")]),
      scan_limit: new FormControl("", [Validators.pattern("[0-9]*")]),
      is_caplimit_overall: new FormControl("", [Validators.required]),
      banner_image: new FormControl(""),
      home_image : new FormControl("")

    });
    console.log("id", this.id, "cartonid", this.cartonid)
    // debugger
    if (this.id == '1') {
      this.getCampaignDetail();
    }
  }

  getCampaignDetail() {
    this.apiService.get(this.apiConfig.CartonCampaignDetail + `?carton_campaign_id=${this.cartonid}`).subscribe((res: any) => {
      console.log(res)
      this.editCarton = res.data.data;
      this.caplimit.emit(res.data.data.is_caplimit_overall)

      console.log(this.editCarton)
    })
  }

  submit() {
    if (this.formGroup.invalid) {
      console.log(this.formGroup)
      this.toast.Error("All fields required")
      return
    } else {
      let scancount = ''
      if (this.formGroup.controls.is_caplimit_overall.value == '0') {
        scancount = ''
      } else {
        scancount = this.formGroup.controls.scan_limit.value;
      }
      if (this.id == '0') {
        let payload = new FormData();
        payload.append("carton_feature_id",this.formGroup.controls.carton_type.value)
        payload.append("carton_campaign_title",this.formGroup.controls.carton_campaign_title.value)
        payload.append("caront_type",this.formGroup.controls.caront_type.value)
        payload.append("start_date",this.formGroup.controls.start_date.value)
        payload.append("end_date",this.formGroup.controls.end_date.value)
        payload.append("month_year",'')
        payload.append("scan_limit",scancount)
        payload.append("is_caplimit_overall",this.formGroup.controls.is_caplimit_overall.value)
        payload.append("banner_image",'')
        payload.append("popup_image",'')

        // let payload = {
        //   carton_type: this.formGroup.controls.carton_type.value,
        //   carton_campaign_title: this.formGroup.controls.carton_campaign_title.value,
        //   caront_type: this.formGroup.controls.caront_type.value,
        //   start_date: this.formGroup.controls.start_date.value,
        //   end_date: this.formGroup.controls.end_date.value,
        //   // module_enable_notification:this.formGroup.controls.module_enable_notification.value,
        //   // module_expiry_notification:this.formGroup.controls.module_expiry_notification.value,
        //   scan_limit: scancount,
        //   is_caplimit_overall: this.formGroup.controls.is_caplimit_overall.value,
        //   banner_image: '',
        //   home_image: '',
        // }
        console.log(payload)
        this.apiService.uploadFile(this.apiConfig.createCartonCampaign, payload).subscribe((res: any) => {
          console.log(res)
          this.createCartonData.emit(true)
          try{
            this.campaignID.emit(res.body.data.id);
            localStorage.setItem("campaign_id", res.body.data.id)
          }
          catch{}
        },err=>{
          // debugger
          console.log('err',err)
          this.toast.Error(err)
        })
      } else {
        let payload = {
          carton_campaign_title: this.formGroup.controls.carton_campaign_title.value,
          caront_type: this.formGroup.controls.caront_type.value,
          start_date: this.formGroup.controls.start_date.value,
          end_date: this.formGroup.controls.end_date.value,
          // module_enable_notification:this.formGroup.controls.module_enable_notification.value,
          // module_expiry_notification:this.formGroup.controls.module_expiry_notification.value,
          scan_limit: scancount,
          is_caplimit_overall: this.formGroup.controls.is_caplimit_overall.value,
        }
        console.log(payload)
        this.apiService.post(this.apiConfig.editCartonCapmpaign + `?id=${this.cartonid}`, payload).subscribe((res: any) => {
          console.log('res', res)
          this.caplimit.emit(parseInt(this.formGroup.controls.is_caplimit_overall.value))
          this.createCartonData.emit(true)
        },err=>{
          debugger
          console.log('err',err)
          this.toast.Error(err)
        })
      }
    }
  }
  selectType(e){
    console.log("event",e)
    this.editCarton.caront_type =e
    this.cartonType.emit(this.editCarton.caront_type)
    console.log(e)
  }

}
